// extracted by mini-css-extract-plugin
export default {"info":"Info_info__RN77k","info__container":"Info_info__container__ZCtxb","info__img":"Info_info__img__bHPXI"};